import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getMeetEvaluationsByOtsMeetIdData from './GetMeetEvaluationsByOtsMeetIdData';
import postMeetEvaluationData from './PostMeetEvaluationData';
import putMeetEvaluationData from './PutMeetEvaluationData';
import deleteMeetEvaluationData from './DeleteMeetEvaluationData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const MeetEvaluationData = {
  INITIAL_STATE, getMeetEvaluationsByOtsMeetIdData,
  postMeetEvaluationData,
  putMeetEvaluationData,
  deleteMeetEvaluationData
};

export default MeetEvaluationData;